import { Dispatch } from 'react'
import { generalOpenModalError, generalShowLoader } from '../general.actions'
import * as http from "../../api/http";
import { ENDPOINTS } from '../../api/config';
import { OPExcel, OPImpresion, OPImpresionIdDte, OPJson, OPSendEmail } from '../../interfaces/operaciones.interface';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { KEYS } from '../../constants/keysStorage';
import { State } from '../../reducers';
import { setResultAnulaciones } from '../historial/historial.actions';
import { isNullOrEmpty } from '../../utils/strings.utils';
import { REGEX_OPERACIONES_MSG } from '../../constants/Regex';
import { convertBase64ToJSON } from '../../utils/file';
// *******************************************************************************************

export const getLogoEmpresa = (): string => {
  return process.env.REACT_APP_UTILITIES + "/logos/" + localStorage.getItem(KEYS.LOGO_EMPRESA);
}

export const sendTransactionEmail =
  (formFilter: OPSendEmail) => async (dispatch: Dispatch<any>, getState: () => State) => {
    dispatch(generalShowLoader(true));
    const userLogin = getState().userLogin
    
    console.log(formFilter)
    const body = {
      ...formFilter,
      Logo: getLogoEmpresa(),
      idEmpresa: userLogin?.datos?.codigo_empresa,
      tokenGateway: localStorage.getItem(KEYS.TOKEN),
      idSucursal: userLogin?.datos.sucursal_seleccionada
    }
    return await http
      .post(ENDPOINTS.OPERACIONES_IMPRESION, body, {}, KEYS.TOKEN)
      .then(async (res: any) => {
        if (res.body) {
          const element = document.createElement('div')
          element.id = 'pdfFactura'
          try {
            let element = res.body.recibo
              .replaceAll('\\n', '')
              .replaceAll('\\r', '')
              .replaceAll('\\', '"')
              .replaceAll('\\t', '')

            element = `<div style="padding: 30px;">${element}</div>`

            // ACTUALIZAR QR
            const parser = new DOMParser();
            const docElement = parser.parseFromString(element, 'text/html');
            element = docElement.documentElement.innerHTML;

            // Medidas A4
            let medidas = {
              altura: 297, // altura de la hoja
              ancho: 210, // ancho de la hoja
              title: `Factura_Correo.pdf`, // titulo del pdf
              subject: `Factura_Correo.pdf`, // asunto del pdf
              windowWidth: 800, // ancho de la ventana visible para el PDF
            } // Por defecto las medidas serán en el tamaño tira A4

            let doc = new jsPDF('p', 'mm', [medidas.altura, medidas.ancho])

            doc.setProperties({
              title: medidas.title,
              subject: medidas.subject,
            })

            await doc.html(element, {
              callback: (doc) => {
                const generatePDF = async () => {
                  const pdfBase64 = await doc.output('datauristring').split(',')[1];
                  await dispatch(sendEmailPDF({ pdf: pdfBase64, ...formFilter }));
                };
                generatePDF();
              },
              margin: [7, 2, 7, 1],
              windowWidth: medidas.windowWidth,
              width: medidas.ancho,
              autoPaging: 'text'
            }).catch((err) => {
              dispatch(generalShowLoader(false))
              dispatch(generalOpenModalError(err?.message ?? 'No fue posible generar el archivo'))
              return false
            })
            return true
          } catch (e: any) {
            dispatch(generalShowLoader(false))
            document.body.removeChild(element)
            dispatch(generalOpenModalError(e?.message ?? 'No fue posible generar el archivo'))
            return false
          }
        } else {
          dispatch(generalShowLoader(false))
          dispatch(generalOpenModalError(res?.internalMessage ?? res?.message ?? 'No fue posible obtener la factura'))
          return false;
        }
      })
      .catch(async (err: any) => {
        dispatch(generalShowLoader(false))
        let message = 'Error al obtener la factura, intente nuevamente'
        await dispatch(generalOpenModalError(err?.response?.data?.message ?? message, err?.response?.data?.status))
        return false;
      })
  }

export const sendEmailPDF = (formEmail: any) => async (dispatch: Dispatch<any>) => {
  dispatch(generalShowLoader(true));
  return await http
    .post(ENDPOINTS.OPERACIONES_ENVIO_CORREO, { ...formEmail }, {}, KEYS.TOKEN)
    .then(async (res: any) => {
      if (res.errorCode === 0) {
        return true;
      } else {
        dispatch(generalOpenModalError(res?.internalMessage ?? res?.message ?? 'No fue posible enviar el correo'))
        return false;
      }
    })
    .catch(async (err: any) => {
      let message = 'Error al enviar el correo, intente nuevamente'
      await dispatch(generalOpenModalError(err?.response?.data?.message ?? message, err?.response?.data?.status))
      return false;
    })
    .finally(() => dispatch(generalShowLoader(false)))
}

export const getImpresionFactura =
  (formImpresion: OPImpresion & { estadoAnulacion?: string | boolean  }) => async (dispatch: Dispatch<any>, getState: () => State) => {
    dispatch(generalShowLoader(true));
    const userLogin = getState().userLogin
    const body = {
      ...formImpresion,
      Logo: getLogoEmpresa(),
      idEmpresa: userLogin?.datos?.codigo_empresa,
      tokenGateway: localStorage.getItem(KEYS.TOKEN),
      idSucursal: userLogin?.datos.sucursal_seleccionada
    }
    return await http
      .post(ENDPOINTS.OPERACIONES_IMPRESION, body, {}, KEYS.TOKEN)
      .then(async (res: any) => {
        if (res.body) {
          let recibido: string = res.body.recibo;
          // Inyectamos la marca de agua si viene anulada
          const flagAnulado = formImpresion.estadoAnulacion === true ||
                              formImpresion.estadoAnulacion === 'true';

          if (flagAnulado) {
            recibido = `
                    <div class="watermark-container">
                      ${recibido}
                    </div>
                    <style>
                      .watermark-container { position: relative; }
                      .watermark-container::before {
                        content: "";
                        position: absolute;
                        top: 0;
                        left: 0;
                        width: 100%;
                        height: 100%;
                        background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='300' height='300'><text x='150' y='150' text-anchor='middle' font-family='Helvetica,Arial,sans-serif' font-weight='bold' font-size='40' fill='rgba(255,0,0,0.1)' transform='rotate(-45 150 150)'>ANULADO</text></svg>");
                        background-repeat: repeat;
                        pointer-events: none;
                        z-index: 9999;
                      }
                    </style>
                  `;
          }

          res.body.recibo = recibido;
          return res.body;
        } else {
          dispatch(generalOpenModalError(res?.internalMessage ?? res?.message ?? 'No fue posible obtener el detalle de la factura'))
          return false;
        }
      })
      .catch(async (err: any) => {
        let message = 'Error al obtener el detalle de la factura. Intente nuevamente.'
        await dispatch(generalOpenModalError(err?.response?.data?.message ?? message, err?.response?.data?.status))
        return false;
      })
      .finally(() => dispatch(generalShowLoader(false)))
  }

export const getImpresionFacturaById =
  (formImpresion: OPImpresionIdDte) => async (dispatch: Dispatch<any>) => {
    dispatch(generalShowLoader(true));
    return await http
      .post(ENDPOINTS.OPERACIONES_IMPRESION_ID, { ...formImpresion, tokenGateway: localStorage.getItem(KEYS.TOKEN) }, {}, KEYS.TOKEN)
      .then(async (res: any) => {
        if (res.body) {
          return res.body;
        } else {
          dispatch(generalOpenModalError(res?.internalMessage ?? res?.message ?? 'No fue posible obtener el detalle de la factura'))
          return false;
        }
      })
      .catch(async (err: any) => {
        let message = 'Error al obtener el detalle de la factura. Intente nuevamente.'
        await dispatch(generalOpenModalError(err?.response?.data?.message ?? message, err?.response?.data?.status))
        return false;
      })
      .finally(() => dispatch(generalShowLoader(false)))
  }

export const getExcelFactura =
  (formExcel: OPExcel, idFactura: string) => async (dispatch: Dispatch<any>) => {
    dispatch(generalShowLoader(true));
    return await http
      .post(ENDPOINTS.OPERACIONES_EXCEL, formExcel, {}, KEYS.TOKEN)
      .then(async (res: any) => {
        if (res.body) {
          const decodedData = atob(res.body.Excel);

          // Crear un array de bytes usando Uint8Array
          const byteArray = new Uint8Array(decodedData.length);
          for (let i = 0; i < decodedData.length; i++) {
            byteArray[i] = decodedData.charCodeAt(i);
          }

          // Crear un Blob con el array de bytes
          const blob = new Blob([byteArray], { type: 'application/vnd.ms-excel' });

          // Crear un enlace de descarga
          const url = URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = "Factura_" + idFactura;

          // Simular un clic en el enlace de descarga
          document.body.appendChild(a);
          a.click();

          // Limpiar el enlace y el objeto URL
          document.body.removeChild(a);
          URL.revokeObjectURL(url);

          return true;
        } else {
          dispatch(generalOpenModalError(res?.internalMessage ?? res?.message ?? 'No fue posible obtener el archivo'))
          return false;
        }
      })
      .catch(async (err: any) => {
        let message = 'Error al obtener el archivo, intente nuevamente'
        await dispatch(generalOpenModalError(err?.response?.data?.message ?? message, err?.response?.data?.status))
        return false;
      })
      .finally(() => dispatch(generalShowLoader(false)))
  }

export const getFacturaPDF =
  (formImpresion: OPImpresion, idFactura: string) => async (dispatch: Dispatch<any>, getState: () => State) => {
    dispatch(generalShowLoader(true));
    const userLogin = getState().userLogin
    const body = {
      ...formImpresion,
      Logo: getLogoEmpresa(),
      idEmpresa: userLogin?.datos?.codigo_empresa,
      tokenGateway: localStorage.getItem(KEYS.TOKEN),
      idSucursal: userLogin?.datos.sucursal_seleccionada
    }
    return await http
      .post(ENDPOINTS.OPERACIONES_IMPRESION, body, {}, KEYS.TOKEN)
      .then(async (res: any) => {
        if (res.body) {
          const element = document.createElement('div');
          element.id = 'pdfFactura';
          try {
            // Incluir contenido con display none
            element.innerHTML = res.body.recibo;
            element.style.display = 'none';
            document.body.appendChild(element);

            const canvas = await html2canvas(element, {
              useCORS: true,
              scale: 3,
              backgroundColor: '#ffffff',
              onclone: (clonedDoc) => {
                const clonedElement = clonedDoc.querySelector('#pdfFactura');
                if (clonedElement) {
                  (clonedElement as HTMLElement).style.display = 'block';
                }
              },
            });
            // Borrar contenido
            document.body.removeChild(element);
            // Descargar pdf
            const imgData = canvas.toDataURL('image/png');
            const margen = 7;
            const imgWidth = 195;
            const imgHeight = (imgWidth / canvas.width) * canvas.height;
            const altoHoja = Math.max(297, imgHeight + margen * 2);
            const doc = new jsPDF('p', 'mm', [altoHoja, 210]);
            doc.addImage(imgData, 'PNG', margen, margen, imgWidth, imgHeight);
            doc.save(`Factura_${idFactura}.pdf`);
            return true;
          } catch (e: any) {
            document.body.removeChild(element);
            dispatch(generalOpenModalError(e?.message ?? 'No fue posible generar el archivo'))
            return false;
          }
        } else {
          dispatch(generalOpenModalError(res?.internalMessage ?? res?.message ?? 'No fue posible obtener el archivo'))
          return false;
        }
      })
      .catch(async (err: any) => {
        let message = 'Error al generar el archivo, intente nuevamente'
        await dispatch(generalOpenModalError(err?.response?.data?.message ?? message, err?.response?.data?.status))
        return false;
      })
      .finally(() => dispatch(generalShowLoader(false)))
  }

export const getFacturaImage =
  (formImpresion: OPImpresion, idFactura: string) => async (dispatch: Dispatch<any>, getState: () => State) => {
    dispatch(generalShowLoader(true));
    const userLogin = getState().userLogin
    const body = {
      ...formImpresion,
      Logo: getLogoEmpresa(),
      idEmpresa: userLogin?.datos?.codigo_empresa,
      tokenGateway: localStorage.getItem(KEYS.TOKEN),
      idSucursal: userLogin?.datos.sucursal_seleccionada
    }

    return await http
      .post(ENDPOINTS.OPERACIONES_IMPRESION, body, {}, KEYS.TOKEN)
      .then(async (res: any) => {
        if (res.body) {
          // Crear div contenedor
          const element = document.createElement('div');
          element.id = 'imageFacturaDiv';
          try {
            // Incluir contenido con display none
            let html = res.body.recibo.replaceAll('\\n', '')
              .replaceAll('\\r', '')
              .replaceAll('\\', '"')
              .replaceAll('\\t', '')
            html = `<div style="padding: 50px;">${html}</div>`

            // ACTUALIZAR QR
            const parser = new DOMParser();
            const docElement = parser.parseFromString(html, 'text/html');
            html = docElement.documentElement.innerHTML;

            element.innerHTML = html;
            element.style.maxWidth = '1000px';
            element.style.overflow = 'hidden';
            element.style.display = 'none';
            document.body.appendChild(element);
            // Crear imagen
            const canvas = await html2canvas(element, {
              useCORS: true,
              scale: 3,
              backgroundColor: '#ffffff',
              onclone: (clonedDoc) => {
                const clonedElement = clonedDoc.querySelector('#imageFacturaDiv');
                if (clonedElement) {
                  (clonedElement as HTMLElement).style.display = 'block';
                }
              },
            });

            // Borrar contenido
            document.body.removeChild(element);
            // Descargar imagen
            const downloadLink = document.createElement('a');
            const imgData = canvas.toDataURL('image/png');
            downloadLink.href = imgData;
            downloadLink.download = `Factura_${idFactura}.png`;
            downloadLink.click();
            return true;
          } catch (e: any) {
            document.body.removeChild(element);
            dispatch(generalOpenModalError(e?.message ?? 'No fue posible generar la imagen'))
            return false;
          }
        } else {
          dispatch(generalOpenModalError(res?.internalMessage ?? res?.message ?? 'No fue posible obtener el archivo'))
          return false;
        }
      })
      .catch(async (err: any) => {
        let message = 'Error al generar el archivo, intente nuevamente'
        await dispatch(generalOpenModalError(err?.response?.data?.message ?? message, err?.response?.data?.status))
        return false;
      })
      .finally(() => dispatch(generalShowLoader(false)))
  }

export const getQR = async (documento: string, extrabody?: any) => {
  let message = 'Se produjo un error al momento de generar el código QR'
  return await http
    .post(ENDPOINTS.FACTURACION_GET_QR, { documento, ...extrabody }, {}, KEYS.TOKEN)
    .then((res: any) => {
      if (res?.body?.QR) return { qr: `data:image/jpeg;base64,${res.body.QR}`, message: '' }
      return { qr: null, message: res?.message ?? message }
    })
    .catch((err) => {
      return { qr: null, message: err?.response?.data?.message ?? message }
    })
}

export const getFacturaPDF_New =
  (formImpresion: OPImpresion, idFactura: string, estadoAnulacion: boolean | string) => async (dispatch: Dispatch<any>, getState: () => State) => {
    dispatch(generalShowLoader(true));
    const userLogin = getState().userLogin
    const body = {
      ...formImpresion,
      Logo: getLogoEmpresa(),
      idEmpresa: userLogin?.datos?.codigo_empresa,
      tokenGateway: localStorage.getItem(KEYS.TOKEN),
      idSucursal: userLogin?.datos.sucursal_seleccionada
    }
    const { config } = getState().userLogin;
    const medidasComprobantes = config!.comprobantesMedidas ?? [];

    return await http
      .post(ENDPOINTS.OPERACIONES_IMPRESION, body, {}, KEYS.TOKEN)
      .then(async (res: any) => {
        if (res.body) {
          const element = document.createElement('div')
          element.id = 'pdfFactura'
          try {
            let element = res.body.recibo
              .replaceAll('\\n', '')
              .replaceAll('\\r', '')
              .replaceAll('\\', '"')
              .replaceAll('\\t', '')

            element = `<div style="padding: 30px;">${element}</div>`

            // ACTUALIZAR QR
            const parser = new DOMParser();
            const docElement = parser.parseFromString(element, 'text/html');
            element = docElement.documentElement.innerHTML;

            // Medidas 
            const medidaConfig = medidasComprobantes.find((medida) =>
              formImpresion.ModoTicket ? medida.ticket : medida.comprobante
            );

            const medidaPorDefecto = formImpresion.ModoTicket
              ? { altura: 200, ancho: 80, windowwidth: 300 }
              : { altura: 297, ancho: 210, windowwidth: 800 };

            let medidas = {
              title: `Factura_${idFactura}.pdf`,
              subject: `Factura_${idFactura}.pdf`,
              altura: medidaConfig?.altura ?? medidaPorDefecto.altura,
              ancho: medidaConfig?.ancho ?? medidaPorDefecto.ancho,
              windowWidth: medidaConfig?.windowwidth ?? medidaPorDefecto.windowwidth,
            };

            let doc = new jsPDF('p', 'mm', [medidas.altura, medidas.ancho])

            doc.setProperties({
              title: medidas.title,
              subject: medidas.subject,
            })

            const rawAnulacion = estadoAnulacion;

            doc.html(element, {
              callback: (doc) => {
                const esAnulado = typeof rawAnulacion === 'boolean' ? rawAnulacion : typeof rawAnulacion === 'string' && rawAnulacion.toLowerCase() === 'true';
                
                if (esAnulado) {
                  const totalPages = doc.getNumberOfPages();
                  const w = doc.internal.pageSize.getWidth();
                  const h = doc.internal.pageSize.getHeight();

                  // Configurar tipografía y estilo
                  doc.setFont("helvetica", "bold");
                  doc.setFontSize(40);
                  doc.setTextColor(255, 0, 0);
                  // Si jsPDF soporta opacidad:
                  // @ts-ignore
                  if (doc.setGState) {
                    // @ts-ignore
                    doc.setGState(new doc.GState({ opacity: 0.1 }));
                  }

                  const texto = "ANULADO";
                  // Espacios entre marcas (en mm)
                  const espacioX = 80;
                  const espacioY = 80;

                  for (let p = 1; p <= totalPages; p++) {
                    doc.setPage(p);
                    // Barrido en X e Y
                    for (let x = -w; x < w * 2; x += espacioX) {
                      for (let y = -h; y < h * 2; y += espacioY) {
                        doc.text(texto, x, y, {
                          align: "center",
                          angle: 45,
                        });
                      }
                    }
                  }
                }

                doc.save(`Factura_${idFactura}.pdf`);
              },
              margin: [7, 2, 7, 1],
              windowWidth: medidas.windowWidth,
              width: medidas.ancho,
              autoPaging: "text",
            });

            return true
          } catch (e: any) {
            document.body.removeChild(element)
            dispatch(generalOpenModalError(e?.message ?? 'No fue posible generar el archivo'))
            return false
          }
        } else {
          dispatch(
            generalOpenModalError(
              res?.internalMessage ?? res?.message ?? 'No fue posible obtener el archivo'
            )
          )
          return false
        }
      })
      .catch(async (err: any) => {
        let message = 'Error al generar el archivo, intente nuevamente'
        await dispatch(generalOpenModalError(err?.response?.data?.message ?? message))
        return false
      })
      .finally(() => dispatch(generalShowLoader(false)))
  }

export interface AnularFacturaResponse { result: boolean; msg: string; }

export const anularFactura =
  (facturas: Array<any>) => async (dispatch: Dispatch<any>, getState: () => State) => {
    const { tipoEstablecimientos, datosEmisor } = getState().catalogos;
    const { datos } = getState().userLogin;
    const resAnulaciones = [];
    const fechaAnulacion = new Date();
    const formattedTime = fechaAnulacion.toTimeString().split(' ')[0];

    dispatch(generalShowLoader(true))
    for (let factura of facturas) {
      const { DetallesDTE } = factura;
      const { emisor, identificacion, receptor, resumen, sujetoExcluido } = DetallesDTE;

      const uuidGenerado = await http
        .get(ENDPOINTS.FACTURACION_GET_UUID, { TipoDOc: identificacion?.tipoDte }, KEYS.TOKEN)
        .then(async (res: any) => {
          if (res.body && !res.message) {
            return res.body
          }
          return false;
        })
        .catch((err) => {
          return false;
        })

      let tipDocSolicitaBk = null;
      if (!receptor?.tipoDocumento) {
        if (receptor?.nit) {
          tipDocSolicitaBk = '36';
        }
      } else {
        tipDocSolicitaBk = receptor?.tipoDocumento;
      }

      if (uuidGenerado?.CodigoGeneracion) {
        const ambienteFact = process.env.REACT_APP_AMBIENTE_FACTURACION;
        const formAnular = {
          idUsuario: localStorage.getItem(KEYS.ID_CLIENT),
          keyTransaction: "",
          tokenGateway: localStorage.getItem(KEYS.TOKEN),
          tokenHacienda: localStorage.getItem(KEYS.HACIENDA) ?? 'null',
          ambiente: ambienteFact,
          idEnvio: 1,
          version: 2,
          documento: factura?.documento,
          documentoAnul: "",
          doc_receptor: receptor?.numDocumento ?? receptor?.nit ?? sujetoExcluido?.numDocumento,
          tipo_doc_receptor: tipDocSolicitaBk ?? sujetoExcluido?.tipoDocumento,
          nrc_receptor: receptor?.nrc ?? null,
          nit_emisor: emisor?.nit,
          nrc_emisor: emisor?.nrc,
          datosAnul: {
            identificacion: {
              version: 2,
              ambiente: ambienteFact,
              codigoGeneracion: uuidGenerado?.CodigoGeneracion,
              fecAnula: identificacion?.fecEmi,
              horAnula: formattedTime
            },
            emisor: {
              nit: emisor?.nit,
              nombre: emisor?.nombre,
              tipoEstablecimiento: emisor?.tipoEstablecimiento ?? datosEmisor.tipoestablecimiento,
              nomEstablecimiento: tipoEstablecimientos.find((estb) => estb.codigo === emisor?.tipoEstablecimiento)?.valor || "ABC",
              codEstableMH: null,
              codEstable: null,
              codPuntoVentaMH: null,
              codPuntoVenta: null,
              telefono: emisor?.telefono,
              correo: emisor?.correo
            },
            documento: {
              tipoDte: identificacion?.tipoDte,
              codigoGeneracion: identificacion?.codigoGeneracion,
              selloRecibido: factura?.sellorecibido,
              numeroControl: identificacion?.numeroControl,
              fecEmi: identificacion?.fecEmi,
              montoIva: resumen?.totalIva,
              codigoGeneracionR: null,
              tipoDocumento: tipDocSolicitaBk ?? sujetoExcluido?.tipoDocumento,
              numDocumento: receptor?.numDocumento ?? receptor?.nit ?? sujetoExcluido?.numDocumento,
              nombre: receptor?.nombre ?? sujetoExcluido?.nombre,
              telefono: receptor?.telefono ?? sujetoExcluido?.telefono,
              correo: receptor?.correo ?? sujetoExcluido?.correo
            },
            motivo: {
              tipoAnulacion: 2,
              motivoAnulacion: "Documento incorrecto",
              nombreResponsable: emisor?.nombre,
              tipDocResponsable: "36", // NIT
              numDocResponsable: emisor?.nit,
              nombreSolicita: receptor?.nombre ?? emisor?.nombre,
              tipDocSolicita: tipDocSolicitaBk ?? "36",
              numDocSolicita: receptor?.numDocumento ?? receptor?.nit ?? emisor?.nit,
            }
          }
        };

        await http
          .post(ENDPOINTS.FACTURACION_ANULAR, formAnular, {}, KEYS.TOKEN)
          .then(async (res: any) => {
            resAnulaciones.push({ doc: identificacion?.numeroControl, result: true, msg: 'Documento anulado correctamente.' })
          })
          .catch(async (err: any) => {
            let message = 'Ocurrió un error al anular el documento, contacta al administrador.'

            if (err?.response?.data?.message) message = err.response.data.message
            else {
              try {
                let messageDesc = err?.response?.data?.body?.descripcionMsg?.replace(REGEX_OPERACIONES_MSG, '').toUpperCase()
                message = messageDesc || message
              } catch { }
            }

            resAnulaciones.push({ doc: identificacion?.numeroControl, result: false, msg: message })
          })
      } else {
        resAnulaciones.push({ doc: identificacion?.numeroControl, result: false, msg: 'Error al generar el código de anulación.' })
      }
    }

    for (const resultado of resAnulaciones) {
      if (resultado.result) {
        const factura = facturas.find(f =>
          f.DetallesDTE?.identificacion?.numeroControl === resultado.doc
        );

        if (!factura) continue;

        const correoReceptor = factura.DetallesDTE.receptor?.correo;
        if (!correoReceptor) continue;
        
        const formEmail: OPSendEmail = {
          Correo: correoReceptor,
          Sello: factura.sellorecibido,
          IdSucursalDoc: factura.DetallesDTE?.identificacion?.IDsucursalDoc || '-1',
          idSucursal: datos.sucursal_seleccionada,
          idEmpresa: `${datos.codigo_empresa}`
        };

        dispatch(sendEmailPDF(formEmail));
      }
    }

    dispatch(setResultAnulaciones(resAnulaciones));
    dispatch(generalShowLoader(false));
    
    return resAnulaciones;  
  }

export const anularFactura_DTE =
  (factura: any) => async (dispatch: Dispatch<any>, getState: () => State) => {
    const { tipoEstablecimientos } = getState().catalogos;
    const { datos } = getState().userLogin;
    const fechaAnulacion = new Date();
    const formattedTime = fechaAnulacion.toTimeString().split(' ')[0];
    const { DetallesDTE } = factura;
    const { emisor, identificacion, receptor, resumen } = DetallesDTE;
    dispatch(generalShowLoader(true))
    
    const uuidGenerado = await http
      .get(ENDPOINTS.FACTURACION_GET_UUID, { TipoDOc: identificacion?.tipoDte }, KEYS.TOKEN)
      .then(async (res: any) => {
        if (res.body && !res.message) {
          return res.body
        }
        return false;
      })
      .catch((err) => {
        return false;
      })

    let tipDocSolicitaBk = null;
    if (!receptor?.tipoDocumento) {
      if (receptor?.nit) {
        tipDocSolicitaBk = '36';
      }
    } else {
      tipDocSolicitaBk = receptor?.tipoDocumento;
    }

    if (uuidGenerado?.CodigoGeneracion) {
      const ambienteFact = process.env.REACT_APP_AMBIENTE_FACTURACION;
      const formAnular = {
        idUsuario: localStorage.getItem(KEYS.ID_CLIENT),
        keyTransaction: "",
        tokenGateway: localStorage.getItem(KEYS.TOKEN),
        tokenHacienda: localStorage.getItem(KEYS.HACIENDA) ?? 'null',
        ambiente: ambienteFact,
        idEnvio: 1,
        version: 2,
        documento: factura?.documento,
        documentoAnul: "",
        doc_receptor: receptor?.numDocumento ?? receptor?.nit ?? null,
        tipo_doc_receptor: tipDocSolicitaBk,
        nrc_receptor: receptor?.nrc ?? null,
        nit_emisor: emisor?.nit,
        nrc_emisor: emisor?.nrc,
        datosAnul: {
          identificacion: {
            version: 2,
            ambiente: ambienteFact,
            codigoGeneracion: uuidGenerado?.CodigoGeneracion,
            fecAnula: identificacion?.fecEmi,
            horAnula: formattedTime
          },
          emisor: {
            nit: emisor?.nit,
            nombre: emisor?.nombre,
            tipoEstablecimiento: emisor?.tipoEstablecimiento,
            nomEstablecimiento: tipoEstablecimientos.find((estb) => estb.codigo === emisor?.tipoEstablecimiento)?.valor || "ABC",
            codEstableMH: null,
            codEstable: null,
            codPuntoVentaMH: null,
            codPuntoVenta: null,
            telefono: emisor?.telefono,
            correo: emisor?.correo
          },
          documento: {
            tipoDte: identificacion?.tipoDte,
            codigoGeneracion: identificacion?.codigoGeneracion,
            selloRecibido: factura?.sellorecibido,
            numeroControl: identificacion?.numeroControl,
            fecEmi: identificacion?.fecEmi,
            montoIva: resumen.totalIva,
            codigoGeneracionR: null,
            tipoDocumento: tipDocSolicitaBk,
            numDocumento: receptor?.numDocumento ?? receptor?.nit ?? null,
            nombre: receptor?.nombre ?? null,
            telefono: receptor?.telefono ?? null,
            correo: receptor?.correo ?? null
          },
          motivo: {
            tipoAnulacion: 2,
            motivoAnulacion: "Documento incorrecto",
            nombreResponsable: emisor?.nombre,
            tipDocResponsable: "36", // NIT
            numDocResponsable: emisor?.nit,
            nombreSolicita: receptor?.nombre ?? emisor?.nombre,
            tipDocSolicita: tipDocSolicitaBk ?? "36",
            numDocSolicita: receptor?.numDocumento ?? receptor?.nit ?? emisor?.nit,
          }
        }
      };
      const response = await http
        .post(ENDPOINTS.FACTURACION_ANULAR, formAnular, {}, KEYS.TOKEN)
        .then(async (res: any) => {
          return true;
        })
        .catch(async (err: any) => {
          dispatch(generalOpenModalError(err?.response?.data?.body?.descripcionMsg ?? 'Error al anular, intente nuevamente.'))
          return false
        })
      
      if (response) {
        const correoReceptor = factura.DetallesDTE.receptor?.correo;
        if (!correoReceptor) return;
        
        const formEmail: OPSendEmail = {
          Correo: correoReceptor,
          Sello: factura.sellorecibido,
          IdSucursalDoc: factura.DetallesDTE?.identificacion?.IDsucursalDoc || '-1',
          idSucursal: datos.sucursal_seleccionada,
          idEmpresa: `${datos.codigo_empresa}`
        };

        await dispatch(sendEmailPDF(formEmail));
      }

      dispatch(generalShowLoader(false));
      return response
    } else {
      dispatch(generalOpenModalError('Error al generar el código de anulación.'))
      dispatch(generalShowLoader(false));
      return false
    }
  }

export function generateQRImageFromBits(bitString: string) {
  if (isNullOrEmpty(bitString)) return ""
  const size = Math.sqrt(bitString.length);

  // Crea un elemento canvas
  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');
  canvas.width = size;
  canvas.height = size;

  let x = 0, y = 0;
  for (let i = 0; i < bitString.length; i++) {
    if (ctx) {
      ctx.fillStyle = bitString[i] === '1' ? 'black' : 'white';
      ctx.fillRect(x, y, 1, 1);
      x++;
      if (x >= size) {
        x = 0;
        y++;
      }
    }
  }

  // Convertir el canvas a una URL de imagen en formato PNG
  return canvas.toDataURL("image/png");
}
export const descargarJson = (jsonForm: OPJson) => (dispatch: Dispatch<any>, getState: () => State) => {
  if (getState().general.loader) return;
  dispatch(generalShowLoader(true));
  try {
    const jsonData = convertBase64ToJSON(jsonForm.json); // decodifica la cadena a json  
    const blob = new Blob([JSON.stringify(jsonData)], { type: 'application/json' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = jsonForm.nombre ? `${jsonForm.nombre}_${jsonForm.idFactura}.json` : `Factura_${jsonForm.idFactura}.json`;
    link.click();
    URL.revokeObjectURL(url);
  } catch (error) {
    dispatch(generalOpenModalError("Error al generar el archivo json.'"))
  } finally {
    dispatch(generalShowLoader(false))
  }
}